import api from "./api";
import useFeatureStore from "../store/useFeatureStore";

export async function GetActivityLogs(id, modelName = "") {
  console.log("model  Name", modelName)
  try {
    const response = await api.get("activity/logs/", {
      params: {
        model_name: modelName,
        object_id: id,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching activity logs:", error);
    throw error;
  }
}

export async function FeatureListApi() {
  try {
    const response = await api.get("subscriptions/feature-flag/");
    return response;
  } catch (error) {
    console.log("Error fetching features:", error);
    throw error;
  }
}

export async function getLatestReleasePopup() {
  try {
    console.log("Calling getLatestReleasePopup API...");
    const response = await api.get("release-notes/popup/");
    console.log("getLatestReleasePopup response:", response);
    return response;
  } catch (error) {
    console.log("Error fetching release popup:", error);
    return { data: { show_popup: false, release: null } };
  }
}

export async function markReleaseAsSeen(releaseId) {
  try {
    const response = await api.post("release-notes/mark-seen/", {
      release_id: releaseId,
    });
    return response;
  } catch (error) {
    console.log("Error marking release as seen:", error);
  }
}